export default __webpack_public_path__ + "static/media/13-min.c85b420d.jpg";